export const NOTIFICACAO_POLL_MS = 60000;
export const NOTIFICACAO_PREVIEW_SIZE = 5;
export const NOTIFICACAO_PAGE_SIZE = 20;

export const NOTIFICACAO_MODULOS = [
  { id: '', label: 'Todos' },
  { id: 'PROCEDIMENTO', label: 'Procedimentos' },
  { id: 'CONVOCACAO', label: 'Convocações' },
  { id: 'HOLERITE', label: 'Holerite' },
  { id: 'DOCUMENTO', label: 'Documentos' },
  { id: 'RELATORIO', label: 'Relatórios' },
];

export const NOTIFICACAO_SITUACOES = [
  { id: 'ACAO_PENDENTE', label: 'Precisa de ação' },
  { id: 'ALERTA', label: 'Só aviso' },
];

export const NOTIFICACAO_LEITURAS = [
  { id: 'nao_lida', label: 'Não lidas' },
  { id: 'lida', label: 'Lidas' },
];

/** @deprecated Prefer NOTIFICACAO_SITUACOES (rótulos oficiais). */
export const NOTIFICACAO_TIPOS = [
  { id: '', label: 'Todas' },
  { id: 'ACAO_PENDENTE', label: 'Ações' },
  { id: 'ALERTA', label: 'Alertas' },
];

const MODULO_LABEL = {
  PROCEDIMENTO: 'Procedimentos',
  CONVOCACAO: 'Convocações',
  HOLERITE: 'Holerite',
  DOCUMENTO: 'Documentos',
  RELATORIO: 'Relatórios',
};

export const moduloLabel = (modulo) => MODULO_LABEL[modulo] || modulo || '';

export const isSafeReferenciaPath = (path) => (
  typeof path === 'string' && path.startsWith('/') && !path.startsWith('//')
);

/** Relatório/download: ação é Baixar, não navegar por `referenciaPath`. */
export const isRelatorioNotificacao = (item) => {
  if (!item) return false;
  if (item.referenciaTipo === 'RELATORIO_JOB') return true;
  return Boolean(item.evento && String(item.evento).indexOf('RELATORIO_') === 0);
};

/** Path que aponta de volta para a própria central — não navega. */
export const isSelfNotificacaoPath = (path) => {
  if (typeof path !== 'string') return false;
  return path === '/v2/notificacoes'
    || path.startsWith('/v2/notificacoes?')
    || path.startsWith('/v2/notificacoes/');
};

export const canNavigateNotificacao = (item) => (
  Boolean(item)
  && !isRelatorioNotificacao(item)
  && isSafeReferenciaPath(item.referenciaPath)
  && !isSelfNotificacaoPath(item.referenciaPath)
);

export const leituraToLidaFilter = (leitura) => {
  if (leitura === 'lida') return true;
  if (leitura === 'nao_lida') return false;
  return undefined;
};

export const buildNotificacaoFilter = ({
  tipo,
  modulo,
  visualizada,
  q,
  arquivada,
} = {}) => {
  const data = {};
  if (tipo) data.tipo = tipo;
  if (modulo) data.modulo = modulo;
  if (visualizada === true || visualizada === false) data.visualizada = visualizada;
  const query = typeof q === 'string' ? q.trim() : '';
  if (query) data.q = query;
  if (arquivada === true || arquivada === false) data.arquivada = arquivada;
  return data;
};

const MODULO_FROM_REFERENCIA = {
  RELATORIO_JOB: 'RELATORIO',
  CONVOCACAO: 'CONVOCACAO',
  PROCEDIMENTO: 'PROCEDIMENTO',
  PROCEDIMENTO_NORMA: 'PROCEDIMENTO',
  HOLERITE: 'HOLERITE',
  DOCUMENTO: 'DOCUMENTO',
  USUARIO_DOCUMENTO: 'DOCUMENTO',
};

/** Lida quando `visualizadaEm` vem preenchido (contrato atual). Aceita `lida` legado. */
export const isNotificacaoLida = (item) => {
  if (!item) return false;
  if (item.visualizadaEm) return true;
  return item.lida === true;
};

export const isNotificacaoArquivada = (item) => {
  if (!item) return false;
  if (item.arquivadaEm) return true;
  return item.arquivada === true;
};

export const getNotificacaoModulo = (item) => {
  if (!item) return '';
  if (item.modulo) return item.modulo;
  if (item.referenciaTipo && MODULO_FROM_REFERENCIA[item.referenciaTipo]) {
    return MODULO_FROM_REFERENCIA[item.referenciaTipo];
  }
  if (item.evento && String(item.evento).indexOf('RELATORIO_') === 0) return 'RELATORIO';
  if (item.evento && String(item.evento).indexOf('CONVOCACAO_') === 0) return 'CONVOCACAO';
  return '';
};

export const normalizeNotificacao = (raw) => {
  if (!raw) return raw;
  return {
    ...raw,
    modulo: getNotificacaoModulo(raw),
    lida: isNotificacaoLida(raw),
    arquivada: isNotificacaoArquivada(raw),
    entregueEm: raw.entregueEm || raw.criadoEm || null,
    visualizadaEm: raw.visualizadaEm || raw.dataLeitura || null,
  };
};

export const parseNotificacaoPage = (data) => {
  const rows = (data && Array.isArray(data.rows))
    ? data.rows
    : (Array.isArray(data) ? data : []);
  return {
    rows: rows.map(normalizeNotificacao),
    totalRows: (data && Number.isFinite(Number(data.totalRows)))
      ? Number(data.totalRows)
      : rows.length,
  };
};

const finiteCount = (metadata, key) => {
  if (!metadata || metadata[key] == null || metadata[key] === '') return null;
  const value = Number(metadata[key]);
  return Number.isFinite(value) ? value : null;
};

export const getConvocacaoContagem = (item) => {
  const metadata = item && item.metadata;
  const aceitas = finiteCount(metadata, 'aceitas');
  const negadas = finiteCount(metadata, 'negadas');
  const expiradas = finiteCount(metadata, 'expiradas');
  if (aceitas == null && negadas == null && expiradas == null) return null;
  return {
    aceitas: aceitas || 0,
    negadas: negadas || 0,
    expiradas: expiradas || 0,
  };
};

export const isRelatorioDisponivel = (item) => item && item.evento === 'RELATORIO_DISPONIVEL';

/** Job ainda em geração — notificação criada pelo BE ao criar o relatórioJob. */
export const isRelatorioGerando = (item) => {
  if (!item) return false;
  if (item.evento === 'RELATORIO_GERANDO' || item.evento === 'RELATORIO_PROCESSANDO') {
    return true;
  }
  const metadata = item.metadata || {};
  const status = metadata.jobStatus || metadata.status;
  return status === 'CREATED' || status === 'PROCESSING';
};

export const getRelatorioJobFromNotificacao = (item) => {
  if (!item) return null;
  const metadata = item.metadata || {};
  const id = metadata.jobId || metadata.relatorioJobId
    || (item.referenciaTipo === 'RELATORIO_JOB' ? item.referenciaId : null)
    || (item.evento && String(item.evento).indexOf('RELATORIO_') === 0 ? item.referenciaId : null);
  if (!id) return null;
  const nomeArquivo = metadata.nomeArquivo || metadata.nome || null;
  const titulo = item.titulo || item.title || '';
  let tipo = metadata.tipo || metadata.jobTipo;
  if (!tipo && (String(nomeArquivo || '').indexOf('CCSM') === 0 || String(titulo).indexOf('CCSM') === 0)) {
    tipo = 'CCSM';
  }
  return {
    id,
    tipo: tipo || 'AUDITORIA_FAIXA',
    nomeArquivo,
  };
};

export const getNomeArquivoNotificacao = (item) => {
  const job = getRelatorioJobFromNotificacao(item);
  return (job && job.nomeArquivo) || '';
};
